import { diasTabelaHorario } from '../constants/dias-tabela-horario'

/**
 * Replica os horários do primeiro dia da grade para os 7 dias da semana.
 */
export function replicarHorarioUnico<T extends Record<string, any>>(
    horarios: T[],
): T[] {
    if (!horarios.length) {
        return []
    }

    const [horarioBase] = horarios

    return diasTabelaHorario.map(label => ({
        ...horarioBase,
        label,
    }))
}
